const storageAvailable = (t) => {
  try {
    const storage = window[t];
    const x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (_e) {
    /* pass */
  }
  return false;
};

let _storage = null;

export const getStorage = () => {
  if (_storage) return _storage;
  if (storageAvailable('localStorage')) _storage = window.localStorage;
  else if (storageAvailable('sessionStorage')) _storage = window.sessionStorage;
  return _storage;
};
